import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/components/Dashboard'
import Report from '@/components/Report'
import BourdonReport from '@/components/BourdonReport'
import AddHomework from '@/components/AddHomework'
import BadGateway from '@/components/BadGateway'
import AddLevel from '@/components/AddLevel'
import EditLevel from '@/components/EditLevel'
import AddGroup from '@/components/AddGroup'
import EditGroup from '@/components/EditGroup'
import EditProgress from '@/components/EditProgress'


import EditPlan from '@/components/EditPlan'
import EditTeacher from '@/components/EditTeacher'
import EditAdmin from '@/components/EditAdmin'
import AddPlan from '@/components/AddPlan'
import Teachers from '@/components/Teachers'
import Admins from '@/components/Admins'
import Levels from '@/components/Levels'
import Groups from '@/components/Groups'
import Plans from '@/components/Plans'
import Students from '@/components/Students'
import PendingStudents from '@/components/PendingStudents'
import AddStudents from '@/components/AddStudents'
import EditStudent from '@/components/EditStudent'
import AddTeacher from '@/components/AddTeacher'
import AddAdmin from '@/components/AddAdmin'
import SelectCategory from '@/components/SelectCategory'
import Payments from '@/components/Payments'
import Homeworks from '@/components/Homeworks'
import Login from '@/components/Login'
import LoginTeacher from '@/components/LoginTeacher'
import TeacherClass from '@/components/TeacherClass'
import TeacherDashboard from '@/components/TeacherDashboard'
import TeacherProfile from '@/components/TeacherProfile'
import TeacherStudents from '@/components/TeacherStudents'
import TeacherPassword from '@/components/TeacherPassword'
import TeacherNotifications from '@/components/TeacherNotifications'
import TeacherMessages from '@/components/TeacherMessages'
import BroadcastAdmin from '@/components/BroadcastAdmin'
import BroadcastTeacher from '@/components/BroadcastTeacher'
import TeacherGroupStudents from '@/components/TeacherGroupStudents.vue';
import WeeklyReport from '@/components/WeeklyReport.vue';


Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [{
            path: '/login',
            name: 'Login',
            props: { page: 5 },
            component: Login
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            props: { page: 1 },
            alias: '/',
            meta: { requiresAuthAdmin: true },

        },
        {
            path: '/report',
            name: 'Report',
            component: Report,
            props: { page: 2 },
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/bourdon-report',
            name: 'BourdonReport',
            component: BourdonReport,
            props: { page: 2 },
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/teachers/:page',
            name: 'Teachers',
            props: { page: 2 },
            component: Teachers,
            meta: { requiresAuthAdmin: true }
        },
        {
            path: '/admins/:page',
            name: 'Admins',
            props: { page: 2 },
            component: Admins,
            meta: { requiresAuthAdmin: true }
        },
        {
            path: '/edit-students/:student_id',
            name: 'EditStudent',
            props: { page: 2 },
            component: EditStudent,
            meta: { requiresAuthAdmin: true }
        },
        {
            path: '/edit-progress/:student_id',
            name: 'EditProgress',
            props: { page: 2 },
            component: EditProgress,
            meta: { requiresAuthAdmin: true }
        },
        {
            path: '/homeworks/:levelId',
            name: 'Homeworks',
            props: { page: 2 },
            component: Homeworks,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-teacher',
            name: 'AddTeacher',
            props: { page: 2 },
            component: AddTeacher,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-admin',
            name: 'AddAdmin',
            props: { page: 2 },
            component: AddAdmin,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/admin-broadcast',
            name: 'BroadcastAdmin',
            props: { page: 2 },
            component: BroadcastAdmin,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/weekly-report',
            name: 'WeeklyReport',
            props: { page: 2 },
            component: WeeklyReport,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/teacher-broadcast',
            name: 'BroadcastTeacher',
            props: { page: 2 },
            component: BroadcastTeacher,
            meta: { requiresAuthTeacher: true },
        },
        {
            path: '/teachter-group-students/:group',
            name: 'TeacherGroupStudents',
            props: { page: 2 },
            component: TeacherGroupStudents,
            meta: { requiresAuthTeacher: true },
        },
        
        {
            path: '/edit-teacher/:user_id',
            name: 'EditTeacher',
            props: { page: 2 },
            component: EditTeacher,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/edit-admin/:user_id',
            name: 'EditAdmin',
            props: { page: 2 },
            component: EditAdmin,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/select-category/:page',
            name: 'SelectCategory',
            props: { page: 2 },
            component: SelectCategory,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/students',
            name: 'Students',
            props: { page: 2 },
            component: Students,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/pending-students',
            name: 'PendingStudents',
            props: { page: 2 },
            component: PendingStudents,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-students',
            name: 'AddStudents',
            props: { page: 2 },
            component: AddStudents,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-homework/:levelId',
            name: 'AddHomework',
            props: { page: 3 },
            component: AddHomework,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/levels/:page/:cat',
            name: 'Levels',
            props: { page: 3 },
            component: Levels,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/groups',
            name: 'Groups',
            props: { page: 3 },
            component: Groups,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/plans',
            name: 'Plans',
            props: { page: 3 },
            component: Plans,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/payments',
            name: 'Payments',
            props: { page: 3 },
            component: Payments,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-plan',
            name: 'AddPlan',
            props: { page: 4 },
            component: AddPlan,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-level',
            name: 'AddLevel',
            props: { page: 8 },
            component: AddLevel,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-group',
            name: 'AddGroup',
            props: { page: 8 },
            component: AddGroup,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/edit-level/:levelId',
            name: 'EditLevel',
            props: { page: 8 },
            component: EditLevel,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/edit-group/:groupId',
            name: 'EditGroup',
            props: { page: 8 },
            component: EditGroup,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/edit-plan/:planId',
            name: 'EditPlan',
            props: { page: 8 },
            component: EditPlan,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/404',
            name: 'BadGateway',
            props: { page: 5 },
            component: BadGateway,
        },
        {
            path: '*',
            props: { page: 5 },
            redirect: '/404'
        },
        {
            path: '/home',
            props: { page: 5 },
            redirect: '/dashboard',
            meta: { requiresAuthAdmin: true },
        },

        {
            path: '/teacher-login',
            name: 'LoginTeacher',
            props: { page: 5 },
            component: LoginTeacher
        },
        {
            path: '/dashboard-teacher',
            name: 'TeacherDashboard',
            props: { page: 5 },
            component: TeacherDashboard,
            meta: { requiresAuthTeacher: true },
        },
        {
            path: '/teacher-class',
            name: 'TeacherClass',
            props: { page: 5 },
            component: TeacherClass,
            meta: { requiresAuthTeacher: true },
        },
        {
            path: '/teacher-profile',
            name: 'TeacherProfile',
            props: { page: 5 },
            component: TeacherProfile,
            meta: { requiresAuthTeacher: true },
        },
        {
            path: '/teacher-students',
            name: 'TeacherStudents',
            props: { page: 5 },
            component: TeacherStudents,
            meta: { requiresAuthTeacher: true },
        },
        {
            path: '/teacher-edit-progress/:student_id',
            name: 'TeacherEditProgress',
            props: { page: 5 },
            component: EditProgress,
            meta: { requiresAuthTeacher: true }
        },
        {
            path: '/teacher-password',
            name: 'TeacherPassword',
            props: { page: 5 },
            component: TeacherPassword,
            meta: { requiresAuthTeacher: true },
        },
        {
            path: '/teacher-notifications',
            name: 'TeacherNotifications',
            props: { page: 5 },
            component: TeacherNotifications,
            meta: { requiresAuthTeacher: true },
        },
        {
            path: '/teacher-messages',
            name: 'TeacherMessages',
            props: { page: 5 },
            component: TeacherMessages,
            meta: { requiresAuthTeacher: true },
        },

    ],

})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuthAdmin)) {
        if (!localStorage.getItem('fastAdminToken')) {
            next({
                name: "Login"
            })
        } else {
            next();
        }
    } else {
        next();
    }

    if (to.matched.some(record => record.meta.requiresAuthTeacher)) {
        if (!localStorage.getItem('fastTeacherToken')) {
            next({
                name: "LoginTeacher"
            })
        } else {
            next();
        }
    } else {
        next();
    }


})

export default router